const mediaQuery = '(min-width: 769px)';
const mediaQueryList = window.matchMedia(mediaQuery);
const randomString = length => {
  return Array.from(Array(length), () => Math.floor(Math.random() * 36).toString(36)).join('');
}

const toOrdinalSuffix = (num) => {
  const int = parseInt(num),
    digits = [int % 10, int % 100],
    ordinals = ['st', 'nd', 'rd', 'th'],
    oPattern = [1, 2, 3, 4],
    tPattern = [11, 12, 13, 14, 15, 16, 17, 18, 19];
  return oPattern.includes(digits[0]) && !tPattern.includes(digits[1])
    ? int + ordinals[digits[0] - 1]
    : int + ordinals[3];
};

class TabWidgetGHD extends HTMLElement {
  constructor() {
    super();

    this.tabLinks = this.querySelectorAll('.tab-nav input');
    this.tabContents = this.querySelectorAll('.tab-contents');

    // hidden all tab contents initially
    this.tabContents.forEach((el) => el.classList.add('hidden'));

    // Listen for active tab and display content
    this.tabLinks.forEach((el) => {
      el.addEventListener('click', (e) => {
        const self = e.target;
        const id = self.id;
        if (!id) return;

        const content = this.querySelectorAll(`.tab-contents[data-content-id="${id}"]`);
        if (!content) return;

        this.tabContents.forEach((el) => el.classList.add('hidden'));
		content.forEach((el) => el.classList.remove('hidden'));

        this.dispatchEvent(new CustomEvent('tab:changed'));
      });
    });
  }
}

customElements.define('tab-widget-ghd', TabWidgetGHD);

class ProductBundlesGHD extends HTMLElement {
  constructor() {
    super();
    this.data = null;

    const script = this.querySelector('script');
    const scriptData = script ? JSON.parse(script.innerHTML) : null;
    if (scriptData) {
	    const { parent, collection, products, section_id } = scriptData;

	    this.data = {
	      parent,
	      collection,
	      section_id,
	      products: products.reduce((acc, obj) => {
	        const [key] = obj.title.split(' in ');
	        const curGroup = acc[key] ?? [];
	        return { ...acc, [key]: [...curGroup, obj] };
	      }, {}),
	      all_products: products
	    }

	    this.selectedProduct = '';

	    console.log(this.data);
	    this.#renderElements();
	    this.#initEvents();
	} else if (this.querySelectorAll('.bundle-item').length) {
		this.#initEvents();
	} else {
		return;
	};
  }
  
  get parentVariantId() {
	  return this.getAttribute("parent-variant-id");
  }
  
  get discountAmmount() {
	  return this.getAttribute("discount-ammount");
  }
  
  get discountMethod() {
	  return this.getAttribute("discount-method");
  }


  #renderElements() {
    const { collection: { metafields: { split_products } }, products } = this.data;
    const splitProducts = split_products ?? null;
    let markup = '';

    if (!products) {
      markup = 'Products not found in this bundle. Please try again';
      this.innerHTML = markup;
      return;
    }

    const renderTabWidget = ({ key, value }, counter) => {
      const uniqueId = randomString(5);
      return `
        <tab-widget-ghd class="tabs" key="${key}">
          <div class="label">Choose ${toOrdinalSuffix(counter)} bundle item</div>
          <div class="tab-nav">
            ${
              value.map(({id, featured_image, handle, title}, index) => {
                const [, color] = title.split(' in ');
                return `
                  <div class="tab-item">
                    <input type="radio" value="${id}" name="${key.toLowerCase().replaceAll(' ', '-')}-${uniqueId}" id="${handle}-${uniqueId}"${index === 0 ? ' checked' : ''} data-image="${featured_image}" data-label="${color}" data-title="${title}" data-href="/products/${handle}" class="hidden">
                    <label for="${handle}-${uniqueId}" data-label="${color}" style="background-image: url('https:${featured_image}');">
                      <span class="hidden">${color}</span>
                    </label>
                  </div>
                `
              }).join('')
            }
          </div>
          ${value.map(({handle, variants}) => {
            return `
              <div class="tab-contents" data-content-id="${handle}-${uniqueId}">
                ${renderVariants(variants)}
              </div>
            `;
          }).join('')}
        </tab-widget-ghd>
      `;
    }

    const renderVariants = (variants) => {
      return `
        ${ variants.length === 1 ?
          `<div class="variant-selector relative">
            <input type="hidden" name="variants" value="${variants[0].id}">
          </div` :
          `<div class="variant-selector relative">
            <div class="label hidden">Select size</div>
            <select class="select" name="variants">
              <option value="" disabled hidden selected>Select your size</option>
              ${
                variants.map(({available, price, compare_at_price, title, id: variantId}) => {
                  let variant_price = compare_at_price != null ? compare_at_price : price;
                  return `<option value="${variantId}" data-price="${price}"${!available ? ' disabled': ''}>${title}</option>`
                }).join('')
              }
            </select>
			  <svg aria-hidden="true" focusable="false" fill="none" width="10" class="icon icon-dropdown-chevron" viewBox="0 0 10 6">
			  <path d="m1 1 4 4 4-4" stroke="currentColor" stroke-linecap="square"></path>
			  </svg>
          </div>`
      }`;
    }

    let counter = 1;
    for (const [key, value] of Object.entries(products)) {
      let [ first, ...rest ] = value;
      const { featured_image, title, media, handle, variants, id: productId } = first;

      markup += `
        <div class="bundle-item">
          <a href="/products/${handle}" class="bundle-item--link">${rest.length > 0 ? `${key} <span class="swatch"></span>` : title }</a>
          ${rest.length > 0 ? renderTabWidget({ key, value }, counter) : renderVariants(variants, counter)}
        </div>
      `;

      if (splitProducts && splitProducts.includes(key)) {
        const currentKey = splitProducts.split(',').find((str) => str.includes(key));

        if (currentKey.includes(':')) {
          const count = +currentKey.split(':').at(-1);
          if (count > 0) {
            rest = value.slice(1, count);
          }
        }

        rest.forEach((el) => {
          counter += 1;

          markup += `
            <div class="bundle-item">
              <a href="/products/${handle}" class="bundle-item--link">${rest.length > 0 ? `${key} <span class="swatch"></span>` : title }</a>
              ${rest.length > 0 ? renderTabWidget({ key, value }, counter) : renderVariants(variants, counter)}
            </div>
          `;
        });
      }

      counter += 1;
    }

    markup += `
      <button type="button" name="submit" class="button w-full" disabled>Please select options</button>
      <div style="position: relative; display: grid; place-items: center">
        <input type="text" name="error-handler" class="hidden" aria-hidden="true">
      </div>
    `;

    this.innerHTML = markup;
  }

  #initEvents() {
    this.submitBtn = this.querySelector('[name="submit"]');

    // Enable / disable add to cart depending on selection
    const toggleSubmitBtn = (e) => {
      const parent = e.target.closest('.bundle-item');
      const hasTabs = parent.querySelector('tab-widget-ghd');

      const activeDropdowns = hasTabs ? this.querySelectorAll('.tab-contents:not(.hidden) [name="variants"]') : this.querySelectorAll('.bundle-item [name="variants"]');
      const allDropdownsHasValue = [...activeDropdowns].every((el) => el.options[el.selectedIndex].value !== '');

      this.submitBtn.disabled = !allDropdownsHasValue;
      this.submitBtn.innerText = allDropdownsHasValue ? 'Add to cart' : 'Please select options'
    }

    const dropdowns = this.querySelectorAll('.bundle-item [name="variants"]');
    dropdowns.forEach((dropdown) => {
      dropdown.addEventListener('change', toggleSubmitBtn);
    });

    const tabs = this.querySelectorAll('tab-widget-ghd');
    tabs.forEach((tab) => {
      tab.addEventListener('tab:changed', (e) => {
        toggleSubmitBtn(e);
      });
    });

    // Load first product variant images
    const bundleItems = this.querySelectorAll('.bundle-item input:checked');
    [...bundleItems].reverse().forEach((el) => {
      el.dispatchEvent(new Event('click'));
    });

    this.submitBtn.addEventListener('click', (e) => {
      this.#validateSubmission()
    });
  }

  async #validateSubmission() {
    const bundleItemElems = this.querySelectorAll('.bundle-item .variant-selector');
    const optionElems = [...bundleItemElems].reduce((acc, el) => {
		const parent = el.parentElement;
		const select = el.querySelector('[name="variants"]');
		if (parent.classList.contains('hidden')) return acc;
		return [...acc, select]
	}, []);
	if (!optionElems) return;
	
    const options = Array.from(optionElems).reduce((acc, el) => {
		const key = el.options[el.selectedIndex].value;
		const curGroup = acc[key] ?? [];
		return { ...acc, [key]: [...curGroup, el] };
    }, {});

    const variants = Object.keys(options).map((key) => key).join('|');
    	
	let items = [], temp = 0, parts = Array.from(optionElems).length, function_data;

	function_data = {
		'type': 'merge',
		'bundleId': Date.now(),
		'percentageDecrease': this.discountAmmount,
		'parentVariantId': this.parentVariantId,
		'bundleIndex': 0
	};

    // Loop through all bundle items
    Object.entries(options).forEach(([key, elems], i, arr) => {
	    elems.forEach((elem, index) => {
			function_data.bundleIndex = index;
			items.push({
				quantity:  1,
				id: +key,
				properties: {
					"_function_data": JSON.stringify(function_data)
				}
			});
		})
    })

    if (items.length === 0) return;

    const errorHandler = this.querySelector('[name="error-handler"]');

    // Fetch form data to cart
    this.submitBtn.classList.add('btn--loading');
    try {
      const res = await fetch('/cart/add.js', {
        method: "POST",
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: items
        })
      });
      const data = await res.json();

      if (res.ok) {
		  document.dispatchEvent(new CustomEvent('cart:refresh', {
			detail: {
				onSuccessDo: 'force_open_drawer'
			}
		}));
      } else {
        console.log({ res, data });
        if (errorHandler) {
          errorHandler.setCustomValidity(`${data.message}: ${data.description}`);
          errorHandler.reportValidity();
          await timeout(2000)
          errorHandler.setCustomValidity('');
        }
      }
    }
    catch (err) {
      console.log(err);
      this.submitBtn.classList.remove('btn--loading');
    }
    finally {
      this.submitBtn.classList.remove('btn--loading');
    }
  }
}

const convertToDecimal = amount => parseInt(+amount, 10) / 100;
const cleanAmount = arg => parseFloat(arg.toFixed(2));
const timeout = (ms) => {
  return new Promise(resolve => setTimeout(resolve, ms));
}

if (!customElements.get('product-bundles-ghd')) {
  customElements.define('product-bundles-ghd', ProductBundlesGHD);
}
